export default __webpack_public_path__ + "static/media/eaton.a9230a8b.webp";